import './styles/base.css';
import './styles/charts.css';
import './styles/glass.css';
import './modules/projects/projects.css';
import './modules/brief/brief.css';
import './modules/review/review.css';
import './modules/roster/roster.css';
import { actions as coreActions, changes as coreChanges } from './core/actions.js';
import { initEvents } from './core/events.js';
import { A, C, UPLOADS } from './core/registry.js';
import { render } from './core/shell.js';
import { S, UI } from './core/store.js';
import { applyTheme } from './core/ui.js';
import { $ } from './core/util.js';
import { MODULES, registerModules } from './modules/index.js';

registerModules();
Object.assign(A, coreActions);
Object.assign(C, coreChanges);
initEvents();
MODULES.forEach((m) => m.init && m.init());
// Shared image chooser: the active section sets UI.upMode, and the matching handler gets the files.
$('#fi').addEventListener('change', (e) => {
  const files = [...e.target.files];
  e.target.value = '';
  const h = UPLOADS[UI.upMode];
  if (files.length && h) h(files);
});
if (window.matchMedia) {
  try { matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => { if (S.theme === 'system') render(); }); } catch (e) { /* older browsers */ }
}
applyTheme();
render();
// Handy for debugging and for the smoke tests.
window.__hub = { S, UI };
